import { readPageState, writePageState } from "@/features/preferences/page-state";
import { useUserSettingsStore } from "@/features/preferences/user-settings.store";
import { gameReviewPath, gameReviewTab } from "./review-navigation";

export const rememberLastReview = (gameId: string, owner: string | null) => {
  if (owner && owner === useUserSettingsStore.getState().ownerUserId) writePageState("games:last-review", gameId);
};

export const lastReviewPath = (gameId: string): string => {
  const saved = readPageState<{ ply: number; moveNumber: number; san: string; tab: string }>(`game:${gameId}`);
  const position =
    saved &&
    Number.isInteger(saved.ply) &&
    saved.ply > 0 &&
    Number.isInteger(saved.moveNumber) &&
    saved.moveNumber > 0 &&
    typeof saved.san === "string"
      ? { ply: saved.ply, moveNumber: saved.moveNumber, san: saved.san }
      : undefined;
  return gameReviewPath(gameId, gameReviewTab(saved?.tab ?? null), position);
};
